import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { clientLog } from 'common/utils/helpers';
import Story from 'client/components/pages/Story';
import Preview from 'client/components/pages/Preview';
import * as routes from 'client/constants/routes';

const log = clientLog.extend('App');

class App extends React.PureComponent {
	previewRoutes = () => (
		<Switch>
			<Route path={routes.ADMIN_PREVIEW_PAGE} component={Preview} />
		</Switch>
	);

	publicRoutes = () => (
		<Switch>
			<Route path={routes.ROOT} component={Story} />
		</Switch>
	);

	render() {
		log('render');

		return (
			<BrowserRouter>
				<Switch>
					<Route path={routes.ADMIN_PREVIEW_PAGE} component={this.previewRoutes} />
					<Route path={routes.ROOT} component={this.publicRoutes} />
					{/* @ts-expect-error ts-migrate FIXME */}
					<Redirect from={routes.ANY} to={routes.ROOT} replace />
				</Switch>
			</BrowserRouter>
		);
	}
}

export default App;
